var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18.7805 7.19024C17.6537 2.2322 13.3288 0 9.52976 0C9.52976 0 9.52976 0 9.51903 0C5.73071 0 1.3951 2.22146 0.268269 7.17951C-0.98734 12.7171 2.40388 17.4068 5.47315 20.358C6.61071 21.4527 8.07025 22 9.52976 22C10.9893 22 12.4488 21.4527 13.5756 20.358C16.6449 17.4068 20.0361 12.7278 18.7805 7.19024ZM9.52976 12.5668C7.66245 12.5668 6.14924 11.0537 6.14924 9.18634C6.14924 7.31903 7.66245 5.80585 9.52976 5.80585C11.3971 5.80585 12.9103 7.31903 12.9103 9.18634C12.9103 11.0537 11.3971 12.5668 9.52976 12.5668Z",
    fill: "#A9A7A7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.7896ac219e4488d769fc009a28a2466e.svg";
export { ForwardRef as ReactComponent };